import { Injectable } from '@angular/core';
import { localStorageGet, localStorageSet } from 'app/shared/utils/window.util';
import { office365LanguageList as localeIds } from 'app/utils/localization';

const baseLocaleMapping: { [key: string]: string } = {
    'en-us': 'en-us',
    en: 'en',
    cs: 'cs',
    de: 'de',
    es: 'es',
    fr: 'fr',
    hu: 'hu',
    id: 'id',
    it: 'it',
    ja: 'ja',
    ko: 'ko',
    nl: 'nl',
    pl: 'pl',
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT',
    ru: 'ru',
    sv: 'sv',
    tr: 'tr',
    'zh-Hans': 'zh-Hans',
    'zh-Hant': 'zh-Hant'
};
export const momentjsLocaleMapping: { [key: string]: string } = {
    ...baseLocaleMapping,
    'pt-BR': 'pt-br',
    'pt-PT': 'pt',
    'zh-Hans': 'zh-cn',
    'zh-Hant': 'zh-tw'
};
export const powerqueryLocaleMapping: { [key: string]: string } = {
    ...baseLocaleMapping,
    'zh-Hans': 'zh-hans',
    'zh-Hant': 'zh-hant',
    en: 'en-us'
};
export const purviewServiceLocaleMapping: { [key: string]: string } = {
    ...baseLocaleMapping
};

@Injectable({
    providedIn: 'root'
})
export class LocalizationService {
    private _localePersistKey: string = 'Redirect_LastUsedLocale';
    private _languageRegionPersistKey: string = 'Redirect_LastUsedLanguageRegion';
    private _languageRegionLabelPersistKey: string = 'Redirect_LastUsedLanguageRegionLabel';

    public getLanguageRegionCode(): string {
        return localStorageGet(this._languageRegionPersistKey) || 'en-US';
    }

    public setLanguageRegionCode(code: string): void {
        // Set code like en-US in localStorage
        localStorageSet(this._languageRegionPersistKey, code);
    }

    public getLanguageRegionLabel(): string {
        return localStorageGet(this._languageRegionLabelPersistKey) || 'English (United States)';
    }

    public setLanguageRegionLabel(label: string): void {
        // i.e., English (United States) in localStorage
        localStorageSet(this._languageRegionLabelPersistKey, label);
    }

    public setLocale(loc: string): void {
        localStorageSet(this._localePersistKey, loc);
    }

    public getLocaleFromUrl(): string {
        const initialHref = document.head.getElementsByTagName('base')[0].href;
        const hrefParts = initialHref.split('/');
        const currentLocale = hrefParts.length > 0 ? hrefParts[hrefParts.length - 1] : undefined;
        const formattedLocalId = currentLocale != null ? localeIds.find((i) => i.toLowerCase() === currentLocale.toLowerCase()) : undefined;
        return formattedLocalId;
    }

    public calcNewLocalizedUrl(newLocale: string): string {
        const initialHref = document.head.getElementsByTagName('base')[0].href;
        const hrefParts = initialHref.split('/');
        const initialUrl = window.location.href.substring(initialHref.length);
        const currentLocale = hrefParts.length > 0 ? hrefParts[hrefParts.length - 1] : undefined;
        const newUrl = initialHref.substring(0, initialHref.indexOf(currentLocale)) + newLocale + initialUrl;
        return newUrl;
    }
}
